/** Same-origin, account-scoped invalidation hints. No notice contents or counts. */
export function connectNotificationTabs(merchantId, accountId, invalidate, environment = window) {
  const key = `bd-notification-sync:v1:${encodeURIComponent(merchantId)}:${encodeURIComponent(accountId)}`;
  const received = new Set();
  let closed = false, channel = null;
  const remember = nonce => {
    received.add(nonce);
    if (received.size > 128) received.delete(received.values().next().value);
  };
  const receive = value => {
    if (closed || value?.version !== 1 || !["READ_CHANGED", "PREFERENCES_CHANGED"].includes(value.type) || typeof value.nonce !== "string"
        || !value.nonce || value.nonce.length > 150 || received.has(value.nonce)) return;
    remember(value.nonce);
    invalidate();
  };
  const storage = event => {
    if (event.key !== key || !event.newValue) return;
    try { receive(JSON.parse(event.newValue)); } catch { /* Ignore unrelated/malformed hints. */ }
  };
  try {
    channel = new environment.BroadcastChannel(key);
    channel.onmessage = event => receive(event.data);
  } catch { /* Storage events and the existing server polling remain available. */ }
  environment.addEventListener("storage", storage);
  return {
    publish(type = "READ_CHANGED") {
      if (closed) return;
      let nonce = `${Date.now()}:${Math.random()}`;
      try { nonce = environment.crypto?.randomUUID?.() || nonce; } catch { /* Hints do not require a security token. */ }
      const value = { version: 1, type, nonce };
      remember(value.nonce);
      try { channel?.postMessage(value); } catch { /* Continue with the storage fallback. */ }
      try { environment.localStorage.setItem(key, JSON.stringify(value)); } catch { /* Polling reconciles blocked storage. */ }
    },
    close() {
      closed = true;
      environment.removeEventListener("storage", storage);
      if (channel) { channel.onmessage = null; channel.close(); }
    },
  };
}
